export const LicenceActionTypes = {
  SET_LICENCE_DATA: 'SET_LICENCE_DATA',
};
